<div class="page-content page-fill">
  @for (event of events; track event) {
    <div class="mb-4">
      <h1>{{ event.sunday }} - {{ event.saturday }}</h1>
      <div class="d-flex phone-display">
        @for (data of event.weekData; track data) {
          <div>
            <div class="d-flex flex-column ms-4">
              <h3 class="event-date">{{ data.date }}</h3>
              @for (detail of data.eventDetails; track detail) {
                <div>
                  <div class="mb-2">
                    <h4 class="event-name">{{ detail.Name }}</h4>
                    <h4>{{ detail.Description }}</h4>
                    <h5 class="event-location">Location: {{ detail.Location }}</h5>
                    <!-- <h4 class="event-location">({{ detail.Location }})</h4> -->
                    <!-- <h5 class="event-times">Start: {{ detail.start }}</h5> -->
                    <!-- <h5 class="event-times">End: {{ detail.end }}</h5> -->
                    <h5 class="event-times">{{ detail.start }} - {{ detail.end }}</h5>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- <h1 class="mt-3">{{ nextSunday }} - {{ nextSaturday }}</h1>
  <div class="d-flex flex-row">
    <div *ngFor="let data of week2">
      <div class="d-flex flex-column ms-4">
        <h3>{{ data.date }}</h3>
        <div *ngFor="let detail of data.Details">
          <div class="mt-3">
            <h4>{{ detail.Name }}</h4>
            <h4>{{ detail.Description }}</h4>
            <h4>Location: {{ detail.Location }}</h4>
            <h5>Start: {{ detail.start }} End: {{ detail.end }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
